export const HOUR_FORMAT = "HH:mm";
export const LAST_UPDATE_FORMAT = "D/MM/YY - HH:mm";

export const ID_STRUTTURA = "idStruttura";
export const ID_PAZIENTE = "idPaziente";
export const INIZIALI_PAZIENTE = "inizialiPaziente";
export const ANNO_NASCITA = "annoNascita";
export const DATA_INTERVENTO = "dataIntervento";
//Info operatorie
export const INGRESSO_BLOCCO_OPERATORIO = "ingressoBloccoOperatorio";
export const INGRESSO_SALA_OPERATORIA = "ingressoSalaOperatoria";
export const USCITA_SALA_OPERATORIA = "uscitaSalaOperatoria";
export const USCITA_BLOCCO_OPERATORIO = "uscitaBloccoOperatorio";
